/* T014/T018 — adresses : défilement natif, boutons et clavier, sans rotation automatique. */
{
  class JaiioAddressCarousel extends HTMLElement {
    connectedCallback() {
      if (this.scroller) return;
      this.scroller = this.querySelector('.pdc-grid');
      this.controls = this.querySelector('.pdc-carousel__controls');
      this.prev = this.querySelector('[data-address-prev]');
      this.next = this.querySelector('[data-address-next]');
      this.status = this.querySelector('[data-address-status]');
      if (!this.scroller || !this.controls || !this.prev || !this.next) return;
      this.onScroll = () => this.update();
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onKey = (event) => {
        // Links within a card keep their own keys and focus behaviour.
        if (event.target !== this.scroller) return;
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.scroller.scrollTo({ left: event.key === 'Home' ? 0 : this.scroller.scrollWidth, behavior: this.behavior() });
        } else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      };
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.scroller.addEventListener('keydown', this.onKey);
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.scroller);
      this.update();
    }
    disconnectedCallback() {
      if (!this.scroller) return;
      this.scroller.removeEventListener('scroll', this.onScroll);
      this.scroller.removeEventListener('keydown', this.onKey);
      this.prev.removeEventListener('click', this.onPrev);
      this.next.removeEventListener('click', this.onNext);
      this.resize.disconnect();
      clearTimeout(this.announceTimer);
      this.scroller = null;
    }
    behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    move(direction) {
      const card = this.scroller.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
      this.scroller.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.behavior() });
    }
    update() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      this.controls.hidden = max <= 2;
      this.prev.disabled = this.scroller.scrollLeft <= 2;
      this.next.disabled = this.scroller.scrollLeft >= max - 2;
      // Announce once scrolling settles, instead of on every animation frame.
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        const frame = this.scroller.getBoundingClientRect();
        const visible = [...this.scroller.children].map((card, i) => ({ box: card.getBoundingClientRect(), i: i + 1 }))
          .filter(({ box }) => box.left < frame.right - 16 && box.right > frame.left + 16);
        if (visible.length && this.status) this.status.textContent = this.dataset.statusTemplate.replace('{first}', visible[0].i).replace('{last}', visible[visible.length - 1].i).replace('{count}', this.dataset.count);
      }, 200);
    }
  }
  if (!customElements.get('jaiio-address-carousel')) customElements.define('jaiio-address-carousel', JaiioAddressCarousel);
}
